module.exports = __webpack_public_path__ + "static/media/learn.b284be10.png";